import React, { useEffect, createElement } from 'react';
import { Link } from 'react-router-dom';
import { SiteNavLinks } from '../components/SiteNavLinks';
const FLYER_IMAGE = 'https://cdn.magicpatterns.com/uploads/2dNSBTn6iSNX6Dy9DTiCmz/1.png';
export function Tour() {
  // Load the Laylo SDK once on mount so the embed renders
  useEffect(() => {
    const SRC = 'https://embed.laylo.com/laylo-sdk.js';
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-276" data-mp="2vyhlg9r969i3">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-277" data-mp="1fkr8sem2icwu">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-278" data-mp="1fn3tv0n4h3e4">
          lennon cripe
        </Link>

        <SiteNavLinks data-id="element-279" data-mp="matle6jno9x1" />

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-280" data-mp="mbbptqgh1ug1">
          contact
        </a>
      </header>

      {/* Tour content */}
      <section className="mt-16 flex w-full flex-col items-center text-sm md:mt-24" data-id="element-281" data-mp="d9venghu1oar">
        {/* Flyer */}
        <img src={FLYER_IMAGE} alt="The first, last and only Florida tour flyer" className="h-auto w-full max-w-md" style={{
        mixBlendMode: 'multiply'
      }} draggable={false} data-id="element-282" data-mp="3uq3jz4oc6x02" />

        {/* Smaller Laylo embed */}
        <div className="mt-6 w-full max-w-xs pb-24" data-id="element-283" data-mp="3pr9162qdd8fy">
          <iframe id="laylo-drop-4ekga-tour" frameBorder="0" scrolling="no" allow="web-share" allowTransparency title="RSVP for updates" style={{
          width: '1px',
          minWidth: '100%',
          maxWidth: '1000px'
        }} src="https://embed.laylo.com?dropId=4ekga&color=000000&minimal=true&theme=light&background=transparent&customTitle=rsvp" data-id="element-284" data-mp="3ps23mriapbsa" />
        </div>
      </section>
    </main>;
}